import script from "./SelectEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectEntity.vue?vue&type=script&setup=true&lang=js"

import "./SelectEntity.vue?vue&type=style&index=0&id=6ffa2540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffa2540"]])

export default __exports__